import _regeneratorRuntime from "@babel/runtime/regenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var makeAuthorizationHeader = function makeAuthorizationHeader(scheme, accessToken) {
  switch (scheme) {
    case 'Token':
      return "Token token=\"".concat(accessToken, "\"");

    case 'Bearer':
      return "Bearer ".concat(accessToken);

    case 'custom':
      return accessToken;

    default:
      throw new Error('Unsupported Authentication scheme provided');
  }
};

var handleHeaderTransportType = function handleHeaderTransportType(config, detail) {
  var token = detail.accessToken || '';
  if (!token) return config;
  config.headers = config.headers || {};
  config.headers[detail.customHeaderName] = makeAuthorizationHeader(detail.tokenType, token);
  return config;
};

export var handleAuthorizationDetail = function handleAuthorizationDetail(authGetter) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(config) {
      var auth;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return authGetter(config);

            case 2:
              auth = _context.sent;

              if (!(auth == null)) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return", config);

            case 5:
              if (!auth.header) {
                _context.next = 7;
                break;
              }

              return _context.abrupt("return", handleHeaderTransportType(config, _objectSpread({
                customHeaderName: 'Authorization'
              }, auth.header)));

            case 7:
              throw new Error('Unrecognized authorization transport type');

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};